<template>
<div id="recovery-codes-alert">
    <div v-if="codes == 0">
        <div class="alert alert-danger">
            <strong>{{$t('NO_RECOVERY_LEFT')}}</strong>
            <p>{{$t('NO_RECOVERY_LEFT_MESSAGE')}}</p>
        </div>
    </div>
    <div v-else-if="codes == 1">
        <div class="alert alert-danger">
            <strong>{{$t('1_RECOVERY_LEFT')}}</strong>
            <p>{{$t('1_RECOVERY_LEFT_MESSAGE')}}</p>
        </div>
    </div>
    <div v-else-if="codes <= 3">
        <div class="alert alert-warning">
            <strong>{{$tc('RECOVERY_CODES_LEFT', codes)}}</strong>
            <p>{{$t('GENERATE_CODES_MESSAGE')}}</p>
        </div>
    </div>
    <div v-else>
        <div class="alert alert-success">
            <strong>{{$tc('RECOVERY_CODES_LEFT', codes)}}</strong>
        </div>
    </div>
</div>
</template>
<script>
    export default {
        data() {
            return {

            }
        },
        props: {
            codes: [Number]
        },
    }
</script>